import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

export const getSubscriptionChangelogUrl = (subscriptionId: number): string =>
  resolveUrl(AppRoute.SubscriptionsChangelog, { id: subscriptionId }) ?? ''

/** The customer's Subscriptions tab opens the details of the subscription named by the hash. */
export const getCustomerSubscriptionUrl = (customerId: number, subscriptionId: number): string =>
  `${resolveUrl(AppRoute.CustomersSubscriptions, { id: customerId }) ?? ''}#${subscriptionId}`
